module.exports = __webpack_public_path__ + "static/media/loader.250dc3fd.gif";